import React, { useState } from 'react';
import { TextField } from '@material-ui/core';

export default function FormInputNumberField({
    label,
    initialValue,
    minValue,
    maxValue,
    maxLength,
    onChangeNumber,
    hasError
}) {
    const regex = RegExp('^[0-9]*$');
    const [currentValue, setCurrentValue] = useState(
        initialValue ? initialValue.toString() : ''
    );

    const updateValue = newValue => {
        const newNumber = parseInt(newValue, 10);
        if (
            (regex.test(newValue) &&
                (minValue === undefined || newNumber >= minValue) &&
                (maxValue === undefined || newNumber <= maxValue)) ||
            newValue === ''
        ) {
            setCurrentValue(newValue);
            if (onChangeNumber) {
                onChangeNumber(newNumber);
            }
        } else if (newValue.length === 1) {
            setCurrentValue('');
        }
    };

    return (
        <div data-testid="number-input-field">
            <TextField
                label={label}
                defaultValue={initialValue}
                value={currentValue}
                onChange={e => updateValue(e.target.value)}
                variant="standard"
                error={hasError}
                data-testid="form-number-input"
                inputProps={{ maxLength: maxLength }}
                style={{ maxWidth: '90%' }}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/v5/termsOfUse/components/FormInputNumberField.js